import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import Navbar from "./components/layout/Navbar";
import AppRoutes from "./components/routing/AppRoutes";
import { TopicProvider } from "./context/TopicContext";
import { AuthProvider } from "./context/AuthContext";
import { ToastProvider } from "./context/ToastContext";
import { ModeProvider } from "./context/ModeContext";
import ErrorBoundary from "./components/common/ErrorBoundary";

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider>
          <TopicProvider>
            <ModeProvider>
              <Router>
                <div className="App">
                  <Navbar />
                  <AppRoutes />
                </div>
              </Router>
            </ModeProvider>
          </TopicProvider>
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
